import React, {FC, useEffect} from 'react';
import {useHistory} from 'react-router';
import {isRedirectHint} from './Redirect';
import {useEnableForced404Page} from './context';
import {isNotFoundHint} from './notFoundPage';

export const RouterErrorHandler: FC<
  React.PropsWithChildren<{error: unknown}>
> = ({children, error}) => {
  const enableForced404Page = useEnableForced404Page();
  const history = useHistory();

  const willHandleError = isNotFoundHint(error) || isRedirectHint(error);

  useEffect(() => {
    if (isNotFoundHint(error)) {
      enableForced404Page();
    } else if (isRedirectHint(error)) {
      const url = new URL(error.redirectTo, window.location.origin);

      if (url.hostname !== window.location.hostname) {
        window.location.href = url.href;
      } else {
        history.replace({
          pathname: url.pathname,
          search: url.search,
          state: history.location.state,
        });
      }
    }
  }, [error, enableForced404Page, history]);

  return willHandleError ? null : <>{children}</>;
};
